<script>
import { Toast } from 'bootstrap'

export default {
  name: 'SingleToast',
  emits: ['destroy'],
  props: {
    title: String,
    message: String,
    type: String,
    errors: Object,
    stay: Number,
    showSpinner: { type: Boolean, default: false },
    autohide: { type: Boolean, default: true },
    id: String,
  },
  computed: {
    classType() {
      return this.type === 'error' ? 'danger' : this.type
    },
    classes() {
      return [`type-${this.classType}`]
    },
    progressBarClasses() {
      return [`bg-${this.classType}`]
    },
    iconClasses() {
      return {
        danger: 'mi-round mi-error',
        success: 'mi-round mi-check',
        info: 'mi-round mi-check',
        warning: 'mi-round mi-warning',
      }[this.classType]
    },
  },
  mounted() {
    const toast = new Toast(this.$el, { delay: this.stay, autohide: this.autohide })
    toast.show()
    this.$el.addEventListener('hidden.bs.toast', () => {
      this.$emit('destroy', this.id)
    })
  },
}
</script>

<template lang="pug">
.toast(:class="classes" aria-atomic="true" aria-live="assertive" role="alert")
  .toast-header
    .icon(:class="iconClasses")
    .me-auto(:class="{ bold: title?.length }" v-html="title?.length ? title : message")
  .toast-body(v-if="title?.length && message?.length" v-html="message")
  button.btn-close(aria-label="Close" data-bs-dismiss="toast" type="button")
  .progress-bar.progress-bar-striped.progress-bar-animated(
    v-if="showSpinner"
    :classes="progressBarClasses"
  )
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables.scss' as themeVariables;
@import '../../../../frontend_stylesheets/_variables.scss';

.toast {
  position: relative;
  padding-top: 12px;
  padding-bottom: 8px;
  padding-right: 40px;
  width: 336px;
  min-height: 48px;
  border: none;
  box-shadow: 0 8px 12px 6px rgba(0, 0, 0, 0.15), 0 4px 4px 0 rgba(0, 0, 0, 0.3);
  color: #fff;
  border-radius: $border-radius;
  background: map.get(themeVariables.$colors, surfaceBright);

  &:has(.toast-body) {
    padding-top: 8px;
  }

  &.type-success {
    background-color: map.get(themeVariables.$toastsColors, success);

    .icon {
      color: #fff;
    }
  }

  &.type-danger {
    background-color: map.get(themeVariables.$toastsColors, error);

    .icon {
      color: #fff;
    }
  }

  &.type-warning {
    background-color: map.get(themeVariables.$toastsColors, warning);

    .icon {
      color: #fff;
    }
  }

  &.type-info {
    background-color: map.get(themeVariables.$toastsColors, info);

    .icon {
      color: #fff;
    }
  }
}

.icon {
  margin-right: 8px;
  font-size: 24px;
}

.progress-bar {
  height: 5px;
}

.btn-close {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  margin: 0;
  padding: 8px;
  filter: invert(1);
  width: 24px;
  height: 24px;
}

.toast-header {
  padding: 0 0 2px 8px;
  min-height: 24px;
  background: transparent;
  color: #fff;
  border-bottom: none;
  font-weight: 600;
}

.toast-body {
  color: #fff;
  padding: 0 8px 0px 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
</style>
